import React, { useState } from 'react'
import CloseIcon from '@material-ui/icons/Close';
import { reasons } from '.'
import styles from '../../pages/hygienist/ProfilePage/components/components.module.scss';
import MaterialInput from 'components/Inputs/MaterialInput';

interface FeedbackProps {
  onClose: () => any
  onSubmit: (data: { answer: string, feedback: string }) => any
}

const Feedback: React.FC<FeedbackProps> = ({ onClose, onSubmit }) => {
  const [selected, setSelected] = useState<any>(null);
  const [answer, setAnswer] = useState('');

  const setAnswerHandler = (item: any) => {
    if (item.id !== 4) {
      setAnswer('');
    }
    setSelected(item);
  };

  return (
    <div className={styles.wizardModalOverlay} onClick={onClose}>
      <div className={styles.wizardModalContainer} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className={styles.wizardModalHeader}>
          <div className={styles.wizardHeaderContent}>
            <h1 className={styles.wizardModalTitle}>Provide Feedback</h1>
            <p className={styles.wizardModalSubtitle}>
              Please tell us why you decided to remove your job post
            </p>
          </div>
          <button className={styles.wizardCloseButton} onClick={onClose} aria-label="Close modal">
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <div className={styles.wizardModalBody}>
          <div className={styles.wizardFormSection}>
            <h3 className={styles.wizardSectionTitle}>Reason for removing your post?</h3>

            {reasons.map((reason) => (
              <div
                key={reason.id}
                className={`${styles.wizardRadioOption} ${selected?.id === reason.id ? styles.selected : ''}`}
                onClick={() => setAnswerHandler(reason)}
              >
                <div className={styles.wizardRadioCircle}>
                  {selected?.id === reason.id && <div className={styles.wizardRadioCircleInner} />}
                </div>
                <div className={styles.radioContent}>
                  <div className={styles.radioLabel}>{reason.text}</div>
                </div>
              </div>
            ))}
          </div>

          <div className={styles.wizardInputContainer}>
            <MaterialInput
              label="Provide Additional Feedback"
              id="feedback"
              name="feedback"
              type="text"
              value={answer}
              onChange={(e: any) => setAnswer(e.target.value)}
              multiline={true}
              rows={4}
              disabled={selected?.id !== 4}
            />
          </div>
        </div>

        {/* Footer */}
        <div className={styles.wizardModalFooter}>
          <button className={styles.wizardCancelButton} onClick={onClose}>
            Cancel
          </button>
          <button
            className={styles.wizardSaveButton}
            onClick={() => onSubmit({
              answer: selected?.text,
              feedback: answer
            })}
            disabled={!selected}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
